import { siteInfo } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[580px] md:min-h-[620px] flex items-center pt-16 overflow-hidden"
    >
      <img
        src="https://readdy.ai/api/search-image?query=Dark%20cinematic%20theater%20atmosphere%20with%20warm%20amber%20and%20deep%20charcoal%20gradient%20background%2C%20subtle%20film%20grain%20texture%2C%20soft%20spotlight%20glow%20from%20top%20left%2C%20elegant%20and%20atmospheric%20movie%20theater%20vibe%20with%20rich%20warm%20tones%2C%20no%20text%2C%20abstract%20cinematic%20composition&width=1800&height=1000&seq=hero-cinema-bg-001&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-top"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-background-50"></div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 text-center lg:text-left w-full">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-500/20 text-accent-200 text-sm font-medium mb-4 backdrop-blur-sm">
              全网热播 · 秒播不缓冲
            </span>

            <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4">
              屁屁影院
              <br />
              <span className="text-primary-300">高清免费在线追剧平台</span>
            </h1>

            <p className="font-heading text-lg md:text-xl text-primary-200 font-medium mb-4">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              {siteInfo.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-8">
              {siteInfo.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-xl md:text-2xl font-extrabold text-white font-label">
                    {stat.value}
                  </div>
                  <div className="text-xs text-white/50 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#ranking"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 hover:bg-primary-400 text-white font-semibold text-sm transition-all duration-200 text-center cursor-pointer"
              >
                <i className="ri-fire-fill mr-2"></i>查看热播排行
              </a>
              <a
                href="#topics"
                className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/10 hover:bg-white/20 text-white font-medium text-sm backdrop-blur-sm border border-white/20 transition-all duration-200 text-center cursor-pointer"
              >
                <i className="ri-compass-3-line mr-2"></i>探索话题标签
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative aspect-[4/5] w-full max-w-sm mx-auto lg:mx-0 lg:ml-auto rounded-2xl overflow-hidden border-2 border-white/15 backdrop-blur-sm">
              <img
                src="https://readdy.ai/api/search-image?query=A%20stunning%20cinematic%20movie%20poster%20collage%20featuring%20dramatic%20lighting%20with%20warm%20golden%20and%20deep%20shadow%20tones%2C%20multiple%20film%20strips%20and%20projector%20light%20overlapping%20in%20artistic%20composition%2C%20elegant%20visual%20storytelling%20aesthetic%2C%20rich%20amber%20and%20cinematic%20color%20grading%2C%20no%20visible%20faces%20or%20text%2C%20abstract%20movie%20art&width=800&height=1000&seq=hero-poster-001&orientation=portrait"
                alt="屁屁影院精选影视内容"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-5">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 rounded-full bg-accent-400 animate-pulse"></div>
                  <span className="text-white/90 text-xs font-medium">今日更新已就绪</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}